import api from './api';

const assetService = {
  getAll:         (token)         => api.get('/assets', token),
  getById:        (id, token)     => api.get(`/assets/${id}`, token),
  create:         (data, token)   => api.post('/assets', data, token),
  update:         (id, data, token) => api.put(`/assets/${id}`, data, token),
  remove:         (id, token)     => api.delete(`/assets/${id}`, token),
  getTransfers:   (token)         => api.get('/assets/transfers', token),
  createTransfer: (data, token)   => api.post('/assets/transfers', data, token),
  getDisposals:   (token)         => api.get('/assets/disposals', token),
  createDisposal: (data, token)   => api.post('/assets/disposals', data, token),
};

export default assetService;
